module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_08_pref"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_09_cor"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CORRIGENDA TO VOLUME")]), _vm._v(" 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_10_ch12"
    }
  }, [_vm._v("12 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MAJORITY OPINION AND CONTEMPORARY DEMOCRACY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_10_ch12#a1"
    }
  }, [_c('i', [_vm._v("The progressive disillusionment about democracy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_10_ch12#a2"
    }
  }, [_c('i', [_vm._v("Unlimited power the fatal effect of the prevailing form of democracy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_10_ch12#a3"
    }
  }, [_c('i', [_vm._v("The true content of the democratic ideal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_10_ch12#a4"
    }
  }, [_c('i', [_vm._v("The weakness of an elective assembly with unlimited powers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_10_ch12#a5"
    }
  }, [_c('i', [_vm._v("Coalitions of organized interests and the apparatus of para-government")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226321264_10_ch12#a6"
    }
  }, [_c('i', [_vm._v("Agreement on general rules and on particular measures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE DIVISION OF DEMOCRATIC POWERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13#a7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The loss of the original conception of the functions of a legislature")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13#a8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Existing representative institutions have been shaped by the needs of government, not of legislation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13#a9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bodies with powers of specific direction are unsuited for law-making")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13#a10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The character of existing ‘legislatures’ determined by their governmental tasks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13#a11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Party legislation leads to the decay of democratic society")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13#a12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The constructivistic superstition of sovereignty")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13#a13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The requisite division of the powers of representative assemblies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_11_ch13#a14",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Democracy or demarchy?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE PUBLIC SECTOR AND THE PRIVATE SECTOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The double task of government")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Collective goods")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The delimitation of the public sector")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The independent sector")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Taxation and the size of the public sector")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Security")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Government monopoly of services")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Information and education")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_12_ch14#a23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Other critical issues")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GOVERNMENT POLICY AND THE MARKET")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The advantages of competition do not depend on it being ‘perfect’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Competition as a discovery procedure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("If the factual requirements of ‘perfect’ competition are absent, it is not possible to make firms act ‘as if’ it existed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a27",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The achievements of the free market")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a28",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Competition and rationality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a29",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Size, concentration and power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a30",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The political aspects of economic power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a31",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("When monopoly becomes harmful")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a32",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The problem of anti-monopoly legislation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a33",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Not individual, but group selfishness is the chief threat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a34",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The consequences of a political determination of the incomes of the different groups")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_13_ch15#a35",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Organizable and non-organizable interests")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_14_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE MISCARRIAGE OF THE DEMOCRATIC IDEAL: A RECAPITULATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_14_ch16#a36",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Miscarriage of the democratic ideal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_14_ch16#a37",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A ‘bargaining’ democracy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_14_ch16#a38",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The playball of group interests")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_14_ch16#a39",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Laws")]), _vm._v(" versus "), _c('i', [_vm._v("directions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_14_ch16#a40",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Laws and arbitrary government")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_14_ch16#a41",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("From unequal treatment to arbitrariness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_14_ch16#a42",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Separation of powers to prevent unlimited government")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A MODEL CONSTITUTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a43",
      "id": "page_ix",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The wrong turn taken by the development of representative institutions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a44",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The value of a model of an ideal constitution")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a45",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The basic principles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a46",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The two representative bodies with distinctive functions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a47",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Further observations on representation by age groups")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a48",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The governmental assembly")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a49",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The constitutional court")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a50",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The general structure of authority")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a51",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Emergency powers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_15_ch17#a52",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The division of financial powers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE CONTAINMENT OF POWER AND THE DETHRONEMENT OF POLITICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a53",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Limited and unlimited power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a54",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Peace, freedom and justice: the three great negatives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a55",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Centralization and decentralization")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a56",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The rule of the majority")]), _vm._v(" versus "), _c('i', [_vm._v("the rule of laws approved by the majority")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a57",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Moral confusion and the decay of language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a58",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Democratic procedure and egalitarian objectives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a59",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("‘State’ and ‘society’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a60",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A game according to rules can never know justice of treatment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a61",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The para-government of organized interests and the hypertrophy of government")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a62",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Unlimited democracy and centralization")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a63",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The devolution of internal policy to local government")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a64",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The abolition of the government monopoly of services")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_16_ch18#a65",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The dethronement of politics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EPILOGUE: THE THREE SOURCES OF HUMAN VALUES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a66",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The errors of sociobiology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a67",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The process of cultural evolution")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a68",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The evolution of self-maintaining complex systems")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a69",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The stratification of rules of conduct")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a70",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Customary rules and economic order")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a71",
      "id": "page_x",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The discipline of freedom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a72",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The re-emergence of suppressed primordial instincts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a73",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Evolution, tradition and progress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a74",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The construction of new morals to serve old instincts: Marx")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a75",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The destruction of indispensible values by scientific error: Freud")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_17_epi#a76",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The tables turned")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_18_note",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_19_index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX OF AUTHORS CITED IN VOLUMES")]), _vm._v(" 1–3")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226321264_20_subind",
      "id": "page_xi",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SUBJECT INDEX TO VOLUMES")]), _vm._v(" 1–3")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2daf0f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226321264_07_toc.vue
// module id = 69
// module chunks = 0